import { combineReducers } from "redux";

import LoginReducer from "../Login/LoginReducer";
import LoanApplicationListReducer from "../LoanApplicationList/LoanApplicationListReducer";
import HeaderReducer from "../Header/HeaderReducer";
import UserReducer from "../UserList/UserListReducer";
import DashBoardReducer from "../Dashboard/DashBoardReducer";
import searchFilterReducer from "./searchFilterReducer";
import AuditTrailReducer from "../AuditTrail/AuditTrailReducer";

export default combineReducers({
  loginReducer: LoginReducer,
  loanApplicationListReducer: LoanApplicationListReducer,
  HeaderReducer: HeaderReducer,
  UserReducer: UserReducer,
  dashBoardReducer: DashBoardReducer,
  searchFilterReducer: searchFilterReducer,
  auditTrailReducer: AuditTrailReducer,
});
